import { AssetData, assets } from 'constants/assets'
import { defaultNetworkName } from 'constants/network'

class AssetService {
  assets: Record<string, AssetData>

  constructor() {
    this.assets = {}
    assets[defaultNetworkName].forEach((asset) => {
      this.assets[asset.terraAddress] = asset
    })
  }

  initAssets(assetDatas: AssetData[]) {
    assetDatas.forEach((assetData) => {
      this.assets[assetData.terraAddress] = assetData
    })
  }

  assetArray = () => {
    return Object.keys(this.assets).map((key) => this.assets[key])
  }
}

export const assetService = new AssetService()
